import { render } from "./FlexBoxDemo.vue?vue&type=template&id=472b838a&scoped=true"
import script from "./FlexBoxDemo.vue?vue&type=script&lang=js"
export * from "./FlexBoxDemo.vue?vue&type=script&lang=js"

import "./FlexBoxDemo.vue?vue&type=style&index=0&id=472b838a&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472b838a"]])

export default __exports__